import { api, type AppelApi } from './client.js';

// contrat à vérifier à l'intégration de pipeline-ventes
export function creerAffairePresentation(
  galerie: string,
  corps: {
    contactId: string;
    lignes: { oeuvreId: string; exemplaireId: string | null; montantCentimes: number }[];
    source: 'manuelle';
  },
  appel: AppelApi,
) {
  return api.post<{ affaire: { id: string } }>(
    `/g/${encodeURIComponent(galerie)}/affaires`,
    corps,
    { galerie, ...appel },
  );
}
